module.exports = __webpack_public_path__ + "static/emp-detail.30ebe571.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/emp-detail.png
// module id = 510
// module chunks = 195485404593854